module.exports = __webpack_public_path__ + "img/no-list-data.283333f9.png";